import { assertCurrentAccessResponse, handleAccessFailure, prepareAccessRequest } from './auth/access';
import type { RequestConfig } from '@umijs/max';
import { requestInterceptor, completeRequest, failedRequest } from './analytics/requests';

const apiBase = 'https://staging-api.aydentify.com';

export const errorConfig: RequestConfig = {
  // baseURL: "https://api-v1.aydentify.com",
  baseURL: apiBase,
  withCredentials: true,
  requestInterceptors: [(config: any) => prepareAccessRequest(config, apiBase), requestInterceptor(apiBase)],
  responseInterceptors: [[(response) => completeRequest(assertCurrentAccessResponse(response)), (error) => { handleAccessFailure(error); return failedRequest(error); }]],
};
